import { TestPlanScreeningType } from '@/app/components/testing-plan/components/your-testing-plan/types';
import { isoDateFormat } from '@/constants/dates';
import { useUpdateTestingPlanTargetDate } from '@/queries/testing-plan.queries';
import { format } from 'date-fns';

export default function useTestingPlanCardController(screeningTypeData: TestPlanScreeningType) {
  const updateTargetDate = useUpdateTestingPlanTargetDate();
  const { name, options } = screeningTypeData;
  const option = options.at(0);

  if (!option) return null;

  const { what, why, testSuggestionId, targetDate } = option;

  const handleDateChange = (date: Date | null) => {
    // Format the date as ISO string (YYYY-MM-DD) to avoid timezone issues
    const formattedDate = date ? format(date, isoDateFormat) : null;

    updateTargetDate.mutate({
      screeningId: testSuggestionId,
      targetDate: formattedDate,
    });
  };

  return {
    name,
    what,
    why,
    testSuggestionId,
    targetDate,
    handleDateChange,
  };
}
